import { render, staticRenderFns } from "./ReservationAppForm.vue?vue&type=template&id=c5412da2&scoped=true"
import script from "./ReservationAppForm.vue?vue&type=script&lang=js"
export * from "./ReservationAppForm.vue?vue&type=script&lang=js"
import style0 from "./ReservationAppForm.vue?vue&type=style&index=0&id=c5412da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5412da2",
  null
  
)

export default component.exports